export class LaminatedCardApplePayCreationDto {
  constructor(data) {
    this.applePayData = data.applePayData;
  }
}
